module.exports = __webpack_public_path__ + "brussels-ceaabd8786e1d540325c55a65c6b90fd.bundle.jpg";